import { render, staticRenderFns } from "./AdminApprove.vue?vue&type=template&id=0cffa842&"
import script from "./AdminApprove.vue?vue&type=script&lang=js&"
export * from "./AdminApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports